
export function escapeHtml(string) {
	if (!string) {
		return string;
	}
	const entityMap = {
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		'"': '&quot;',
		"'": '&#39;'
	};

	return String(string).replace(/[&<>"']/g, function (s) {
		return entityMap[s];
	});
}

function isPlainObject(obj) {
	return Object.prototype.toString.call(obj) === '[object Object]';
}

function escapeRichText(text, handler) {
	if (!text) {
		return text;
	}

	if (typeof handler === 'function') {
		text = handler(text);
	}

  text = typeof text === 'string' ? text : String(text);

  return text.replace(/&lt;br&gt;/g, function () {
                return `<br>`
              }
            ).replace(/&lt;div style=&quot;(.*?)&quot;&gt;(.*?)&lt;\/div\s*&gt;/g, function (a, b, c) {
              return `<div style="${b}">${c}</div>`
            }).replace(/&lt;div&gt;(.*?)&lt;\/div&gt;/g, function (a, b) {
              return `<div>${b}</div>`
            }).replace(/&lt;p style=&quot;(.*?)&quot;&gt;(.*?)&lt;\/p\s*&gt;/g, function (a, b, c) {
              return `<p style="${b}">${c}</p>`
            }).replace(/&lt;p(.*?)&gt;(.*?)&lt;\/p\s*&gt;/g, function (a, b, c) {
              return `<p>${c}</p>`
            }).replace(/&lt;span style=&quot;(.*?)&quot;&gt;(.*?)&lt;\/span\s*&gt;/g, function (a, b, c) {
              return `<p style="${b}">${c}</p>`
            }).replace(/&lt;span(.*?)&gt;(.*?)&lt;\/span\s*&gt;/g, function (a, b, c) {
              return `<p>${c}</p>`
            }).replace(/&lt;\s*img\s*src=&quot;http(.*?)&quot;.*?style=&quot;(.*?)&quot;&gt;/g, function (a, b, c) {
              return `<img src="http${b}" style="${c}">`;
            });
}

export function processRichText(value) {
	let beforeEscape;
	let afterEscape;
	let richText = '';

	if (isPlainObject(value)) {
		beforeEscape = value['beforeEscape'];
		afterEscape = value['afterEscape'];
		richText = value['text'];
		if (value['trust']) {
			// 提供了完全信任使用不转义的方式
			return richText || '';
		}
	} else if (typeof value === 'string') {
		richText = value;
	}

	richText = escapeRichText(richText, beforeEscape);
	richText = escapeHtml(richText);
	richText = escapeRichText(richText, afterEscape);

	return richText;
}
